import React, { useEffect, useState } from 'react'
import { Card, Form, Input, Button, Drawer, Tabs } from 'antd'
import {
    UploadOutlined,
    FacebookOutlined,
    TwitterOutlined,
    LinkedinOutlined,
    GoogleOutlined,
    InstagramOutlined
} from '@ant-design/icons'
import UploadPage from './UploadPage'
import { GeneralService } from '../Services/generalService'
import { notify } from '../customs/NotifyProvider'

const { TextArea } = Input
const { TabPane } = Tabs

const ConfigPage = () => {
    const [form] = Form.useForm()
    const [openDrawer, setOpenDrawer] = useState(false)
    const [configId, setConfigId] = useState(null)

    // 🔹 Fetch Config
    const fetchConfig = async () => {
        try {
            const res = await GeneralService.get("config")

            console.log("Config Response:", res?.data)

            if (res?.data?.length > 0) {
                const config = res.data[0]

                setConfigId(config.id)
                form.setFieldsValue(config)
            }
        } catch (err) {
            console.error(err)
            notify.error("Failed to load config")
        }
    }

    useEffect(() => {
        fetchConfig()
    }, [])

    // 🔹 Submit Handler
    const handleFinish = async (values) => {
        console.log("Updated Values:", values)

        try {
            let response

            if (configId) {
                response = await GeneralService.update("config", configId, values)
            } else {
                response = await GeneralService.create("config", values)
            }

            if (response?.status) {
                notify.success(response.message || "Updated successfully")
                fetchConfig()
            } else {
                notify.error(response.message || "Something went wrong")
            }

        } catch (err) {
            console.error(err)
            notify.error("Server error")
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '24px',
            }}
        >
            <Card title="General Configurations" style={{ width: '50rem' }}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                >

                    {/* Chat Number */}
                    <Form.Item label="Chat Number" name="chat_no">
                        <Input />
                    </Form.Item>

                    {/* Emergency Number */}
                    <Form.Item label="Top Bar Contact Number" name="top_bar_contact">
                        <Input />
                    </Form.Item>

                    <Form.Item label="Emergency Number" name="emergency_no">
                        <Input />
                    </Form.Item>

                    {/* Address */}
                    <Form.Item label="Address" name="address">
                        <TextArea rows={4} />
                    </Form.Item>

                     <Form.Item label="Copy right text" name="copy_right">
                        <Input />
                    </Form.Item>

                    {/* BG IMAGE */}
                    <Form.Item label="Background Image (Image size 2626 × 750)">
                        <Button
                            icon={<UploadOutlined />}
                            onClick={() => setOpenDrawer(true)}
                            style={{ marginBottom: 10 }}
                        >
                            Upload Image
                        </Button>

                        <Form.Item name="bg_image" noStyle>
                            <Input placeholder="Paste uploaded image URL here" />
                        </Form.Item>
                    </Form.Item>

                    {/* 🔹 Social Media Tabs */}
                    <Tabs defaultActiveKey="1" style={{ marginTop: 20 }}>

                        <TabPane
                            tab={<><FacebookOutlined /> Facebook</>}
                            key="1"
                        >
                            <Form.Item label="Facebook URL" name="facebook">
                                <Input placeholder="https://facebook.com/yourpage" />
                            </Form.Item>
                        </TabPane>

                        <TabPane
                            tab={<><TwitterOutlined /> Twitter</>}
                            key="2"
                        >
                            <Form.Item label="Twitter URL" name="twitter">
                                <Input placeholder="https://twitter.com/yourhandle" />
                            </Form.Item>
                        </TabPane>

                        <TabPane
                            tab={<><LinkedinOutlined /> LinkedIn</>}
                            key="3"
                        >
                            <Form.Item label="LinkedIn URL" name="linkedin">
                                <Input placeholder="https://linkedin.com/in/yourprofile" />
                            </Form.Item>
                        </TabPane>

                        <TabPane
                            tab={<><GoogleOutlined /> Google+</>}
                            key="4"
                        >
                            <Form.Item label="Google+ URL" name="google_plus">
                                <Input placeholder="https://plus.google.com/yourprofile" />
                            </Form.Item>
                        </TabPane>

                        <TabPane
                            tab={<><InstagramOutlined /> Instagram</>}
                            key="5"
                        >
                            <Form.Item label="Instagram URL" name="instagram">
                                <Input placeholder="https://instagram.com/yourprofile" />
                            </Form.Item>
                        </TabPane>

                    </Tabs>

                    {/* Submit */}
                    <Form.Item style={{ marginTop: 20 }}>
                        <Button type="primary" htmlType="submit" block>
                            Update Configuration
                        </Button>
                    </Form.Item>

                </Form>
            </Card>

            {/* Drawer for Upload */}
            <Drawer
                title="Upload Image"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                width={800}
            >
                <UploadPage
                    onUpload={(url) => {
                        form.setFieldsValue({ bg_image: url })
                        setOpenDrawer(false)
                    }}
                />
            </Drawer>
        </div>
    )
}

export default ConfigPage